<form id="siteAreaForm" appPromptUnsubmitted (ngSubmit)="save()">
    <div class="row">
        <div class="col-md-6">
            <div class="row">
                <div class="form-group col-sm-4">
                    <label for="siteCode">Planting ID</label>
                    <input class="form-control"
                           name="sitecode"
                           id="siteCode"
                           type="text"
                           placeholder="(Autogenerated)"
                           [(ngModel)]="selectedSiteArea.code"
                           [disabled]="!currentUser?.permissions.canManagePlantingSites"
                           >
                </div>
                <div class="form-group col-sm-8">
                    <label for="name">Name of area</label>
                    <input class="form-control" name="title" [appIsInvalid]="!selectedSiteArea.name"
                        [(ngModel)]="selectedSiteArea.name" required id="name" type="text" value="Wonderland">
                    <div class="invalid-feedback">
                        Name is Required.
                    </div>
                </div>

                <div class="form-group col-sm-12">
                    <div class="row">
                        <div class="col-sm-6">
                            <label for="date">Year</label>
                            <select class="form-control custom-select" name="year"
                                [appIsInvalid]="!selectedSiteArea.year" [(ngModel)]="selectedSiteArea.year" id="date">
                                <option *ngFor="let year of years" [value]="year">{{year}}</option>
                            </select>
                            <div class="invalid-feedback">
                                Year is Required.
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group col-sm-6">
                    <label for="name">KML (Planting Area) </label>
                    <ng-container *ngIf="!isKMLUpload else hasKMLFile">
                        <div class="input-group">
                            <div class="custom-file" >
                                <input type="file" class="custom-file-input " id="inputGroupFileKML" (change)="onFileKMLUpload($event)"
                                 accept=".kml">
                                <label class="custom-file-label btn-file" for="inputGroupFileKML"
                                    aria-describedby="inputGroupFileAddon02"><i class="icon-cloud-upload"></i>
                                    Upload file</label>
                            </div>
                            <div class="invalid-feedback">
                                Error message!!
                            </div>
                        </div>
                        <span class="help-text" [hidden]="!isKMLUpload">Date</span>
                    </ng-container>
                    <ng-template #hasKMLFile>
                        <div class="input-group">
                            <input type="text" class="form-control"
                                aria-label="Recipient's username" [value]="kmlFileName" aria-describedby="button-addon2"
                                disabled>
                            <div class="input-group-append">
                                <button class="btn btn-danger" type="button" (click)="onFileKMLDelete($event)"><i class="icon-trash"></i></button>
                                <button class="btn btn-primary" type="button" id="button-kmlFile" (click)="onClickKML(selectedSiteArea.kmlUrl)" [hidden]="!uploadKML"><i class="icon-cloud-download"></i></button>
                            </div>

                        </div>
                    </ng-template>
                </div>
                <div class="form-group col-sm-6">
                    <label for="name">Flight path (csv) </label>
                    <ng-container *ngIf="!isFlightPathUpload else hasFlightPathFile">
                        <div class="input-group">
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" id="inputGroupFileFlightPath" (change)="onFileFlightPathUpload($event)"
                                  accept=".csv">
                                <label class="custom-file-label btn-file" for="inputGroupFileFlightPath"
                                    aria-describedby="inputGroupFileAddon02"><i class="icon-cloud-upload"></i>
                                    Upload file</label>
                                <div class="invalid-feedback">
                                    Error message!!
                                </div>
                            </div>
                        </div>
                        <span class="help-text" *ngIf="isFlightPathUpload">Date</span>
                    </ng-container>
                    <ng-template #hasFlightPathFile>
                        <div class="input-group">
                            <input type="text" class="form-control"
                                aria-label="Recipient's username" [value]="flightPathName" aria-describedby="button-addon2"
                                disabled >
                            <div class="input-group-append">
                                <button class="btn btn-danger" type="button" (click)="onFileFligthPathDelete($event)"><i class="icon-trash"></i></button>
                                <button class="btn btn-primary" type="button" id="button-flightPathFile" [hidden]="!uploadFlightPath" (click)="onClickFlightPath(selectedSiteArea.flightPathUrl)"><i class="icon-cloud-download"></i></button>
                            </div>
                        </div>
                    </ng-template>
                </div>

                <div class="form-group col-12">
                    <label for="name">Description of the planting </label>
                    <small class="float-right">{{selectedSiteArea.description?.length}}</small>
                    <textarea class="form-control"
                              [(ngModel)]="selectedSiteArea.description"
                              id="description"
                              name="description"
                              rows="3"
                              placeholder="Write a description.."
                              [disabled]="!currentUser?.permissions.canManagePlantingSites"></textarea>
                </div>

                <div class="form-group col-12">
                    <label for="photo">Top banner and thumbnail image</label>
                    <app-photo-upload [existingPhotoUrl]="selectedSiteArea.photo?.originalUrl" (photoSelected)="onPhotoSelected($event)"></app-photo-upload>
                </div>
            </div>
        </div>

    </div>
    <div class="save-button-area">
        <button type="submit" form="siteAreaForm" class="btn btn-primary">Save</button>
        <button type="button" class="btn btn-outline-dark" [routerLink]="['..']">Cancel</button>
    </div>


</form>
